import React from 'react'
import style from './Main.module.css'

const Main = () => {
  return (
    <>
      <main className="main">
        <div className={style.mainVisual}>
          <div className={style.mainVisualTitle}>
            <h1 className="pb-3 h2">HY교육에 오신걸 환영합니다.</h1>
            <p className="h5">
              개인의 장점에 맞춘 차별화된 입시 솔루션을 제공합니다.
              <br />
              HY에서 통합 맞춤 컨설팅을 받아보세요!
            </p>
          </div>

          <div className={style.mainVisualVideo}>
            <div className={style.videoWrap}>
              <iframe
                className={style.videoIframe}
                src="https://www.youtube.com/embed/OdXbQvTJ7wQ?autoplay=1&mute=1&loop=1&playlist=OdXbQvTJ7wQ&controls=0&modestbranding=1&rel=0"
                title="[HY교육] 프리미엄 스터디카페 : 공간에 교육을 더하다."
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"></iframe>
            </div>
          </div>
        </div>
      </main>
    </>
  )
}

export default Main
